import { c as _c } from "react/compiler-runtime";
import { Input, Spinner } from '@common/components';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { useId, useState } from 'react';
import type { SEARCH_PARAMS_TYPE } from '@/constants';
import type { SelectedRegion } from './RegionPickerDialog';
import { RegionPickerDialog } from './RegionPickerDialog';
import { useRegionMetaData } from './useRegionMetaData';
interface RegionSelectProps {
  value?: SEARCH_PARAMS_TYPE.SELECTED_REGION;
  onChange?: (value: SelectedRegion) => void;
  id?: string;
  className?: string;
  labelClassName?: string;
  label?: string;
  placeholder?: string;
  isLoading?: boolean;
  enableMainRegionCodeList?: string[];
  enableWholeRegion?: boolean;
  enableWholeCountry?: boolean;
}
export const RegionSelect = t0 => {
  const $ = _c(36);
  const {
    value,
    onChange,
    id,
    className,
    labelClassName,
    label: t1,
    isLoading: t2,
    enableMainRegionCodeList,
    enableWholeRegion: t3,
    enableWholeCountry: t4,
    placeholder: t5
  } = t0;
  const label = t1 === undefined ? "\uC9C0\uC5ED" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const enableWholeRegion = t3 === undefined ? false : t3;
  const enableWholeCountry = t4 === undefined ? false : t4;
  const placeholder = t5 === undefined ? "\uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694." : t5;
  const regionMetaDataQuery = useRegionMetaData();
  const regionMetaData = regionMetaDataQuery.data;
  const [opened, setOpened] = useState(false);
  const inputId = useId();
  let t6;
  if ($[0] !== regionMetaData?.mainRegionByCode || $[1] !== value) {
    t6 = value?.mainRegionCode ? regionMetaData?.mainRegionByCode.get(value.mainRegionCode) : undefined;
    $[0] = regionMetaData?.mainRegionByCode;
    $[1] = value;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const mainRegion = t6;
  let t7;
  if ($[3] !== regionMetaData?.subRegionByCode || $[4] !== value) {
    t7 = value?.subRegionCode ? regionMetaData?.subRegionByCode.get(value.subRegionCode) : undefined;
    $[3] = regionMetaData?.subRegionByCode;
    $[4] = value;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const subRegion = t7;
  const selectedRegionText = !mainRegion ? enableWholeCountry ? "\uC804\uAD6D" : "" : subRegion ? `${mainRegion.value} > ${subRegion.value}` : enableWholeRegion && value?.mainRegionCode ? `${mainRegion.value} 전체` : "";
  const isPending = isLoading || regionMetaDataQuery.isLoading;
  let t8;
  if ($[6] !== id || $[7] !== inputId || $[8] !== label || $[9] !== labelClassName) {
    t8 = <div className="mb-10 flex w-full items-center justify-between gap-4 text-Gray-800 typo-body4"><label className={labelClassName} htmlFor={inputId} id={id}>{label}</label></div>;
    $[6] = id;
    $[7] = inputId;
    $[8] = label;
    $[9] = labelClassName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isPending) {
    t9 = isPending ? <Spinner size={20} /> : <SvgChevrondown className="size-20 text-Gray-700" name={"\uC5F4\uAE30"} />;
    $[11] = isPending;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isPending) {
    t10 = () => {
      if (isPending) {
        return;
      }
      setOpened(true);
    };
    $[13] = isPending;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== inputId || $[16] !== placeholder || $[17] !== selectedRegionText || $[18] !== t10 || $[19] !== t9) {
    t11 = <Input readOnly={true} className="w-full" id={inputId} placeholder={placeholder} rightContent={t9} type="button" value={selectedRegionText} onClick={t10} />;
    $[15] = inputId;
    $[16] = placeholder;
    $[17] = selectedRegionText;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setOpened(false);
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== onChange) {
    t13 = region => onChange?.(region);
    $[22] = onChange;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== enableMainRegionCodeList || $[25] !== enableWholeCountry || $[26] !== enableWholeRegion || $[27] !== opened || $[28] !== t13 || $[29] !== value) {
    t14 = <RegionPickerDialog opened={opened} onClose={t12} onConfirm={t13} value={value} title={"\uAD00\uC2EC \uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694"} enableMainRegionCodeList={enableMainRegionCodeList} enableWholeRegion={enableWholeRegion} enableWholeCountry={enableWholeCountry} />;
    $[24] = enableMainRegionCodeList;
    $[25] = enableWholeCountry;
    $[26] = enableWholeRegion;
    $[27] = opened;
    $[28] = t13;
    $[29] = value;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== className || $[32] !== t11 || $[33] !== t14 || $[34] !== t8) {
    t15 = <div className={className}>{t8}{t11}{t14}</div>;
    $[31] = className;
    $[32] = t11;
    $[33] = t14;
    $[34] = t8;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};